import React from "react";
import { capitalize } from "../../utils/textFunctions";

const Telecom = ({ data, summary: isSummary }) => {
  if (isSummary) {
    return null;
  }

  if (data.length === 0) {
    return (
      <section>
        <h3>Contact Information</h3>
        <div>
          <h4>Empty</h4>
        </div>
      </section>
    );
  }

  return (
    <section>
      <h3>Contact Information</h3>
      <div>
        <div>
          <h4>System</h4>
        </div>
        <div>
          <h4>Value</h4>
        </div>
        <div>
          <h4>Use</h4>
        </div>
      </div>

      {data.map((contactMethod, index) => {
        return (
          <div key={index}>
            <div>
              <div>{capitalize(contactMethod.system)}</div>
            </div>
            <div>
              <div>{contactMethod.value}</div>
            </div>
            <div>
              <div>{capitalize(contactMethod.use)}</div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Telecom;
